<template>
  <div class="game-info">
    <div class="game-info__col">
      <div class="game-info__row game-info__card col-mobile">
        <div class="game-info__row">
          <img :src="Level" alt="Icon" />
          <p>مرحله اول</p>
        </div>
        <div class="game-info__row">
          <img :src="Heart1" alt="Icon" />
          <p>2 سوت طلا</p>
        </div>
      </div>
      <div class="game-info__row game-info__card col-mobile">
        <div class="game-info__row">
          <img :src="Level" alt="Icon" />
          <p>مرحله دوم</p>
        </div>
        <div class="game-info__row">
          <img :src="Heart2" alt="Icon" />
          <p>5 سوت طلا</p>
        </div>
      </div>

      <div class="game-info__row game-info__card col-mobile">
        <div class="game-info__row">
          <img :src="Level" alt="Icon" />
          <p>مرحله سوم</p>
        </div>
        <div class="game-info__row">
          <img :src="Heart3" alt="Icon" />
          <p>10 سوت طلا</p>
        </div>
      </div>
    </div>
    <ButtonBar
      :button-icon="Close"
      class="game-info__close-btn close-user-info-click"
      @click="emit('closeInfo')"
    />
  </div>
</template>

<script setup>
import Heart1 from '~/assets/images/heart1.svg'
import Heart2 from '~/assets/images/heart2.svg'
import Heart3 from '~/assets/images/heart3.svg'
import Level from '~/assets/images/level.svg'
import Close from '~/assets/images/close.png'

const emit = defineEmits(['closeInfo'])
</script>

<style lang="scss" scoped>
.game-info {
  width: 90%;
  margin: 0 auto;
  width: 100%;
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  padding-top: 45px;
  background: #653684;
  z-index: 100000;
  height: 100dvh;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  @media screen and (max-width: 924px) {
    width: 100%;
  }

  &__col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 30px;
    width: 100%;
  }

  &__card {
    background-color: #fff;
    border-radius: 20px;
    width: 80%;
    box-shadow: 0px 8px 0px 0px rgba(0, 0, 0, 0.25);
    border: 1px solid #cdd5df;
    padding: 10px 0;
    gap: 30px !important;

    @media screen and (max-width: 768px) {
      gap: 20px !important;
    }
  }

  &__row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    p {
      color: $talineContentSecondary;
      font-size: 24px;
    }
  }

  &__close-btn {
    width: 200px;
    margin: 0 auto;
    margin-top: 50px;
  }
}
</style>
